var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('el-dialog', {
    attrs: {
      "visible": _vm.innerVisible,
      "show-close": false,
      "close-on-click-modal": false,
      "close-on-press-escape": false,
      "custom-class": "deposit-promo-dialog",
      "width": _vm.view === 'payment' ? '520px' : '760px',
      "append-to-body": ""
    },
    on: {
      "update:visible": function ($event) {
        _vm.innerVisible = $event;
      }
    }
  }, [_c('div', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: _vm.pageLoading,
      expression: "pageLoading"
    }],
    staticClass: "dp-body"
  }, [_vm.view === 'reminder' ? [_c('div', {
    staticClass: "dp-header"
  }, [_c('div', {
    staticClass: "dp-title"
  }, [_c('span', {
    staticClass: "dp-flag"
  }, [_vm._v("🏮")]), _vm._v("\n          店铺费用缴纳提醒\n        ")])]), _vm._v(" "), _vm.isUSD ? _c('div', {
    staticClass: "dp-rate"
  }, [_vm._v("\n        💱 实时汇率："), _c('b', [_vm._v(_vm._s(_vm.rateText))]), _vm._v(" "), _c('span', {
    staticClass: "dp-rate-time"
  }, [_vm._v("（取自 " + _vm._s(_vm.rateTime) + "）")])]) : _vm._e(), _vm._v(" "), _vm.bannerType === 'partial' ? _c('div', {
    staticClass: "dp-banner dp-banner--warning"
  }, [_vm._v("\n        ⚠ 单项不足：" + _vm._s(_vm.rejectedNames) + "审核未通过，请根据下方原因重新提交凭证。\n      ")]) : _vm.bannerType === 'rejected' ? _c('div', {
    staticClass: "dp-banner dp-banner--error"
  }, [_vm._v("\n        ✕ 审核未通过：请确认金额与转账信息无误后重新上传凭证。\n      ")]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "dp-desc"
  }, [_vm._v("\n        您的店铺"), _c('b', [_vm._v("尚未完成费用缴纳")]), _vm._v("，请完成以下费用缴纳后即可开始经营：\n      ")]), _vm._v(" "), _c('div', {
    staticClass: "dp-cards"
  }, [_vm.deposit ? _c('div', {
    staticClass: "dp-card"
  }, [_c('div', {
    staticClass: "dp-card-name"
  }, [_vm._v("店铺保证金")]), _vm._v(" "), _c('div', {
    staticClass: "dp-card-amount",
    class: _vm.statusColorClass(_vm.deposit.status)
  }, [_vm._v("\n            " + _vm._s(_vm.currencySymbol) + _vm._s(_vm.formatAmount(_vm.deposit.expectedAmount)) + "\n          ")]), _vm._v(" "), _c('div', {
    staticClass: "dp-card-sub"
  }, [_vm._v("\n            基础保证金 " + _vm._s(_vm.currencySymbol) + _vm._s(_vm.formatAmount(_vm.deposit.baseAmount)) + "\n          ")]), _vm._v(" "), Number(_vm.deposit.specialAmount) ? _c('div', {
    staticClass: "dp-card-sub"
  }, [_vm._v("\n            特殊品类保证金 " + _vm._s(_vm.currencySymbol) + _vm._s(_vm.formatAmount(_vm.deposit.specialAmount)) + "\n          ")]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "dp-card-status"
  }, [_c('span', {
    staticClass: "dp-dot",
    class: _vm.statusDotClass(_vm.deposit.status)
  }), _vm._v("\n            " + _vm._s(_vm.statusText(_vm.deposit.status)) + "\n          ")]), _vm._v(" "), _vm.deposit.status === 4 && _vm.deposit.rejectReason ? _c('div', {
    staticClass: "dp-card-reason"
  }, [_vm._v("\n            原因：" + _vm._s(_vm.deposit.rejectReason) + "\n          ")]) : _vm._e()]) : _vm._e(), _vm._v(" "), _vm.promoFund ? _c('div', {
    staticClass: "dp-card"
  }, [_c('div', {
    staticClass: "dp-card-name"
  }, [_vm._v("首笔推广金")]), _vm._v(" "), _c('div', {
    staticClass: "dp-card-amount",
    class: _vm.statusColorClass(_vm.promoFund.status)
  }, [_vm._v("\n            " + _vm._s(_vm.currencySymbol) + _vm._s(_vm.formatAmount(_vm.promoFund.expectedAmount)) + "\n          ")]), _vm._v(" "), _c('div', {
    staticClass: "dp-card-status"
  }, [_c('span', {
    staticClass: "dp-dot",
    class: _vm.statusDotClass(_vm.promoFund.status)
  }), _vm._v("\n            " + _vm._s(_vm.statusText(_vm.promoFund.status)) + "\n          ")]), _vm._v(" "), _vm.promoFund.status === 4 && _vm.promoFund.rejectReason ? _c('div', {
    staticClass: "dp-card-reason"
  }, [_vm._v("\n            原因：" + _vm._s(_vm.promoFund.rejectReason) + "\n          ")]) : _vm._e()]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "dp-card-actions"
  }, [_vm.deposit ? _c('el-button', {
    staticClass: "dp-item-btn",
    attrs: {
      "type": "danger",
      "disabled": !_vm.isPayable(_vm.deposit.status)
    },
    on: {
      "click": function ($event) {
        return _vm.goPay([1]);
      }
    }
  }, [_vm._v("\n          " + _vm._s(_vm.deposit.status === 4 ? '重新上传' : '保证金缴纳上传凭证') + "\n        ")]) : _vm._e(), _vm._v(" "), _vm.promoFund ? _c('el-button', {
    staticClass: "dp-item-btn",
    attrs: {
      "type": "danger",
      "disabled": !_vm.isPayable(_vm.promoFund.status)
    },
    on: {
      "click": function ($event) {
        return _vm.goPay([2]);
      }
    }
  }, [_vm._v("\n          " + _vm._s(_vm.promoFund.status === 4 ? '重新上传' : '推广金缴纳上传凭证') + "\n        ")]) : _vm._e()], 1), _vm._v(" "), _c('div', {
    staticClass: "dp-total-action"
  }, [_vm.payableFundTypes.length ? _c('el-button', {
    staticClass: "dp-total-btn",
    on: {
      "click": function ($event) {
        return _vm.goPay(_vm.payableFundTypes);
      }
    }
  }, [_vm._v("\n          " + _vm._s(_vm.totalButtonText) + "\n        ")]) : _c('el-button', {
    staticClass: "dp-total-btn",
    attrs: {
      "disabled": _vm.hasPending
    },
    on: {
      "click": _vm.onFinish
    }
  }, [_vm._v("\n          已完成\n        ")])], 1)] : [_c('div', {
    staticClass: "dp-pay-header"
  }, [_vm._v("缴纳开店费用")]), _vm._v(" "), _c('div', {
    staticClass: "dp-pay-total-label"
  }, [_vm._v("应缴总计")]), _vm._v(" "), _c('div', {
    staticClass: "dp-pay-total"
  }, [_vm._v(_vm._s(_vm.currencySymbol) + _vm._s(_vm.formatAmount(_vm.payTotal)))]), _vm._v(" "), _c('div', {
    staticClass: "dp-pay-breakdown"
  }, [_vm.payTargets.includes(1) && _vm.deposit ? [_c('div', {
    staticClass: "dp-bd-row"
  }, [_c('span', [_vm._v("基础保证金")]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.currencySymbol) + _vm._s(_vm.formatAmount(_vm.deposit.baseAmount)))])]), _vm._v(" "), Number(_vm.deposit.specialAmount) ? _c('div', {
    staticClass: "dp-bd-row"
  }, [_c('span', [_vm._v("特殊品类保证金")]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.currencySymbol) + _vm._s(_vm.formatAmount(_vm.deposit.specialAmount)))])]) : _vm._e()] : _vm._e(), _vm._v(" "), _vm.payTargets.includes(2) && _vm.promoFund ? _c('div', {
    staticClass: "dp-bd-row"
  }, [_c('span', [_vm._v("首笔推广金")]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.currencySymbol) + _vm._s(_vm.formatAmount(_vm.promoFund.expectedAmount)))])]) : _vm._e()], 2), _vm._v(" "), _c('div', {
    staticClass: "dp-tabs"
  }, _vm._l(_vm.availableMethods, function (m) {
    return _c('div', {
      key: m.code,
      staticClass: "dp-tab",
      class: {
        'is-active': _vm.paymentMethod === m.code
      },
      on: {
        "click": function ($event) {
          _vm.paymentMethod = m.code;
        }
      }
    }, [_vm._v("\n          " + _vm._s(m.name) + "\n        ")]);
  }), 0), _vm._v(" "), _vm.paymentMethod === 1 ? _c('div', {
    staticClass: "dp-bank"
  }, [_vm.bankTransferInfo ? _c('div', {
    staticClass: "dp-bank-box"
  }, [_c('div', {
    staticClass: "dp-bank-row"
  }, [_c('span', {
    staticClass: "dp-bank-label"
  }, [_vm._v("收款账户")]), _vm._v(" "), _c('span', {
    staticClass: "dp-bank-value"
  }, [_vm._v(_vm._s(_vm.bankTransferInfo.accountName))]), _vm._v(" "), _c('span', {
    staticClass: "dp-copy",
    on: {
      "click": function ($event) {
        return _vm.copy(_vm.bankTransferInfo.accountName);
      }
    }
  }, [_vm._v("复制")])]), _vm._v(" "), _vm.bankTransferInfo.companyAddress ? _c('div', {
    staticClass: "dp-bank-row"
  }, [_c('span', {
    staticClass: "dp-bank-label"
  }, [_vm._v("公司地址")]), _vm._v(" "), _c('span', {
    staticClass: "dp-bank-value"
  }, [_vm._v(_vm._s(_vm.bankTransferInfo.companyAddress))]), _vm._v(" "), _c('span', {
    staticClass: "dp-copy",
    on: {
      "click": function ($event) {
        return _vm.copy(_vm.bankTransferInfo.companyAddress);
      }
    }
  }, [_vm._v("复制")])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "dp-bank-row"
  }, [_c('span', {
    staticClass: "dp-bank-label"
  }, [_vm._v("开户银行")]), _vm._v(" "), _c('span', {
    staticClass: "dp-bank-value"
  }, [_vm._v(_vm._s(_vm.bankTransferInfo.bankName))]), _vm._v(" "), _c('span', {
    staticClass: "dp-copy",
    on: {
      "click": function ($event) {
        return _vm.copy(_vm.bankTransferInfo.bankName);
      }
    }
  }, [_vm._v("复制")])]), _vm._v(" "), _vm.bankTransferInfo.bankAddress ? _c('div', {
    staticClass: "dp-bank-row"
  }, [_c('span', {
    staticClass: "dp-bank-label"
  }, [_vm._v("银行地址")]), _vm._v(" "), _c('span', {
    staticClass: "dp-bank-value"
  }, [_vm._v(_vm._s(_vm.bankTransferInfo.bankAddress))]), _vm._v(" "), _c('span', {
    staticClass: "dp-copy",
    on: {
      "click": function ($event) {
        return _vm.copy(_vm.bankTransferInfo.bankAddress);
      }
    }
  }, [_vm._v("复制")])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "dp-bank-row"
  }, [_c('span', {
    staticClass: "dp-bank-label"
  }, [_vm._v("收款账号")]), _vm._v(" "), _c('span', {
    staticClass: "dp-bank-value"
  }, [_vm._v(_vm._s(_vm.bankTransferInfo.bankAccount))]), _vm._v(" "), _c('span', {
    staticClass: "dp-copy",
    on: {
      "click": function ($event) {
        return _vm.copy(_vm.bankTransferInfo.bankAccount);
      }
    }
  }, [_vm._v("复制")])]), _vm._v(" "), _vm.bankTransferInfo.swiftCode ? _c('div', {
    staticClass: "dp-bank-row"
  }, [_c('span', {
    staticClass: "dp-bank-label"
  }, [_vm._v("SWIFT")]), _vm._v(" "), _c('span', {
    staticClass: "dp-bank-value"
  }, [_vm._v(_vm._s(_vm.bankTransferInfo.swiftCode))]), _vm._v(" "), _c('span', {
    staticClass: "dp-copy",
    on: {
      "click": function ($event) {
        return _vm.copy(_vm.bankTransferInfo.swiftCode);
      }
    }
  }, [_vm._v("复制")])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "dp-bank-row"
  }, [_c('span', {
    staticClass: "dp-bank-label"
  }, [_vm._v("转账附言")]), _vm._v(" "), _c('span', {
    staticClass: "dp-bank-value"
  }, [_vm._v(_vm._s(_vm.transferRemark))]), _vm._v(" "), _c('span', {
    staticClass: "dp-copy",
    on: {
      "click": function ($event) {
        return _vm.copy(_vm.transferRemark);
      }
    }
  }, [_vm._v("复制")])])]) : _vm._e()]) : _c('div', {
    staticClass: "dp-alipay"
  }, [_vm.alipayInfo ? _c('img', {
    staticClass: "dp-qr",
    attrs: {
      "src": _vm.alipayInfo.qrCodeUrl
    }
  }) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "dp-qr-tip"
  }, [_vm._v("请使用法人支付宝 App 扫一扫")]), _vm._v(" "), _c('ul', {
    staticClass: "dp-tips"
  }, _vm._l(_vm.alipayTips, function (tip, i) {
    return _c('li', {
      key: i,
      staticClass: "dp-tip"
    }, [_c('span', {
      staticClass: "dp-tip-badge"
    }, [_vm._v(_vm._s(i + 1))]), _vm._v(" "), _c('span', {
      staticClass: "dp-tip-text"
    }, [_vm._v(_vm._s(tip))])]);
  }), 0)]), _vm._v(" "), _c('el-upload', {
    staticClass: "dp-upload",
    attrs: {
      "drag": "",
      "action": "#",
      "accept": '.jpg,.jpeg,.png,.pdf',
      "auto-upload": false,
      "show-file-list": true,
      "file-list": _vm.uploadFileList,
      "limit": 3,
      "multiple": "",
      "on-change": _vm.onFileChange,
      "on-remove": _vm.onFileRemove,
      "on-exceed": _vm.onExceed
    }
  }, [_c('i', {
    staticClass: "el-icon-paperclip dp-upload-icon"
  }), _vm._v(" "), _c('div', {
    staticClass: "dp-upload-text"
  }, [_vm._v("\n          点击上传" + _vm._s(_vm.paymentMethod === 1 ? '转账' : '支付宝支付') + "凭证\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "dp-upload-hint"
  }, [_vm._v("支持 JPG / PNG / PDF，单文件 ≤ 5MB")])]), _vm._v(" "), _c('div', {
    staticClass: "dp-bank-warning"
  }, [_vm._v("\n        ⚠ 请确保转账金额与应缴金额一致。凭证提交后财务将进行审核。\n      ")]), _vm._v(" "), _c('div', {
    staticClass: "dp-pay-footer"
  }, [_c('el-button', {
    on: {
      "click": function ($event) {
        _vm.view = 'reminder';
      }
    }
  }, [_vm._v("返回")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "danger",
      "loading": _vm.submitting,
      "disabled": !_vm.voucherKeys.length
    },
    on: {
      "click": _vm.onSubmit
    }
  }, [_vm._v("\n          " + _vm._s(_vm.payTargets.length > 1 ? '提交（合并支付）' : '提交') + "\n        ")])], 1)]], 2)]);
}
var staticRenderFns = []

export { render, staticRenderFns }